import script from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"
export * from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"

import "./fromThirdReg.vue?vue&type=style&index=0&id=7fd9f1f2&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd9f1f2"]])

export default __exports__